module.exports = __webpack_public_path__ + "img/discord44x34.a933492e.png";